const itemsInPage = 20;

const loadMorePages = 10;

module.exports = {
  itemsInPage,
  loadMorePages,
};
